import { Box } from '@mui/material'
import { successCheckStyles } from 'components/core/action-icons/styles'
import { C1Icon } from 'components/core/icons/C1Icon'
import { CircleCheck } from 'lucide-react'
import { FC } from 'react'

export const SuccessCheck: FC<{ className?: string }> = ({ className }) => {
    return (
        <Box sx={successCheckStyles.checkMark}>
            <C1Icon icon={CircleCheck} className={className} />
        </Box>
    )
}
